import { Autocomplete, TextField } from "@mui/material"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import DialogTitle from "@mui/material/DialogTitle"
import { StyledButton } from "components/Button/StyledButton"
import { Employee, Task, User } from "graphql/types"
import { useStoreActions, useStoreState } from "hooks/storeHooks"
import { useEffect, useState } from "react"

type AddExaminatorDialogProps = {
  open: boolean
  onClose: () => void
  task: Task | undefined
  onChangeExaminator: (task: Task, user: User) => void
}

export const AddExaminatorDialog = (props: AddExaminatorDialogProps) => {
  const { open, onClose, task, onChangeExaminator } = props
  const employees = useStoreState((state) => state.employees)
  const [selectedEmployee, setSelectedEmployee] = useState<Employee | null>(null)

  const { fetchEmployees } = useStoreActions((actions) => actions)

  useEffect(() => {
    const loadEmployees = async () => {
      try {
        await fetchEmployees({ fresh: false })
      } catch (err) {
        console.error("Error loading employees:", err)
      }
    }
    if (open && (!employees || employees.length === 0)) {
      loadEmployees()
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open])

  // Find current examinator in employees list
  const currentExaminator = task?.examinator
    ? employees?.find((emp) => emp.id === task.examinator?.id)
    : null

  return (
    <Dialog open={open} fullWidth>
      <DialogTitle sx={{ px: 1 }}>Prüfer ändern</DialogTitle>
      <DialogContent sx={{ p: 1 }}>
        <Autocomplete
          sx={{ mt: 1 }}
          size="small"
          fullWidth
          value={currentExaminator || null}
          id="tags-outlined"
          options={employees || []}
          renderOption={(props, option) => (
            <li {...props} key={option.id}>
              {option.EmployeeName || "N/A"}
              {option.ContactInfo?.Email && (
                <span style={{ marginLeft: 8, fontSize: "0.9em", opacity: 0.7 }}>
                  ({option.ContactInfo.Email})
                </span>
              )}
            </li>
          )}
          renderInput={(params) => <TextField {...params} />}
          onChange={(_, value) => {
            if (value) {
              setSelectedEmployee(value)
            }
          }}
        />
      </DialogContent>
      <DialogActions>
        <StyledButton buttonType="cancel" fullWidth variant="contained" onClick={onClose} />
        <StyledButton
          buttonType="save"
          fullWidth
          disabled={!selectedEmployee}
          variant="contained"
          onClick={() => {
            if (selectedEmployee && task) {
              // Convert Employee to User format
              const user: User = {
                id: selectedEmployee.id,
                displayName: selectedEmployee.EmployeeName,
                email: selectedEmployee.ContactInfo?.Email,
                userPrincipalName: selectedEmployee.ContactInfo?.Email,
              }
              onChangeExaminator(task, user)
            }
          }}
        />
      </DialogActions>
    </Dialog>
  )
}
